import { render, staticRenderFns } from "./aventus.vue?vue&type=template&id=5d4de98e&scoped=true&"
import script from "./aventus.vue?vue&type=script&lang=js&"
export * from "./aventus.vue?vue&type=script&lang=js&"
import style0 from "./aventus.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./aventus.vue?vue&type=style&index=1&id=5d4de98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4de98e",
  null
  
)

export default component.exports